import dynamic from 'next/dynamic';
import { EmailInfoProps } from './ReslinkEmailInfo.types';

export const ReslinkEmailInfo = dynamic<{ model: EmailInfoProps }>(() =>
  import('./ReslinkEmailInfo').then(mod => mod.ReslinkEmailInfo)
);
